import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { EMPTY_ORG_ID } from "@/constants/org";
import { assetQueryOptions } from "@/services/asset/asset.options";
import { AdminAssetTypeFullIndexTabContent } from "./full";

const FULL_INDEX =
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: AdminAssetTypeFullIndexRoute,
});

function AdminAssetTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		assetQueryOptions.typeDetail(params.assetTypeId, {
			organizationId: EMPTY_ORG_ID,
		}),
	);

	const assetType = detailQuery.data ?? null;

	if (!assetType) {
		return null;
	}

	return (
		<AdminAssetTypeFullIndexTabContent tab={search.tab} assetType={assetType} />
	);
}
